import React, { Suspense, lazy } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom"; // ✅ Fixed import
import "./App.css";
import Header from "./shared/header/header";
import Footer from "./shared/footer/footer";
import "@fortawesome/fontawesome-free/css/all.min.css";
import LandShipping from "./pages/LandShipping";

// ✅ Lazy load pages for better performance
const Home = lazy(() => import("./pages/home"));
const Services = lazy(() => import("./pages/service"));
const About = lazy(() => import("./pages/about"));
const AirShipping = lazy(() => import("./pages/AirShipping"));
const SEAShipping = lazy(() => import("./pages/SeaShipping"));

function App() {
  return (
    <Router>
      <div className="App">
        {/* ✅ Header */}
        <Header />

        {/* ✅ Suspense wrapper for lazy-loaded components */}
        <main className="main-content">
          <Suspense fallback={<div className="loading">Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/air-shipping" element={<AirShipping />} />
              <Route path="/land-shipping" element={<LandShipping />} />
              <Route path="/sea-shipping" element={<SEAShipping />} />
            </Routes>
          </Suspense>
        </main>

        {/* ✅ Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;